import { isBoolean, unset, forEach, isEmpty, isEqual, merge, set, get } from 'lodash';

import { Adapter } from './adapter';

export class AdobeTagManagerAdapter extends Adapter {
  static get #defaultOptions() {
    return {
      dataLayerName: 'dataLayer',
    };
  }

  get type() {
    return 'adobe';
  }

  constructor({ logger, adapterOptions = {} }) {
    super({ logger: logger.withPrefix('adobe') });

    adapterOptions = {
      ...AdobeTagManagerAdapter.#defaultOptions,
      ...adapterOptions,
    };

    this.log('adapter configured', { adapterOptions });
  }

  get #satellite() {
    return (
      window._satellite || {
        track: (event, detail = {}) => {
          this.log('_satellite.track call:', {
            event,
            detail,
            digitaldata: this.#digitaldata,
          });
        },
      }
    );
  }

  get #digitaldata() {
    return window.digitaldata || {};
  }

  #setDigitalData(newData, options = {}) {
    if (isBoolean(options)) {
      options = { mergeData: options };
    }

    const mergeData = get(options, 'mergeData', true);
    const omitKeys = get(options, 'omitKeys', []);

    const before = this.#digitaldata;
    const after = { ...(mergeData ? merge(before, newData) : newData) };

    omitKeys.forEach((key) => {
      if (isEmpty(key)) {
        return;
      }

      this.log('unsetting digitaldata keys', { key, value: get(after, key) });
      const removed = unset(after, key);
      this.log(`removed ${key}:`, removed ? 'yes' : 'no');
    });

    this.log('setting digitaldata', { newData, mergeData, before, after, omitKeys });
    window.digitaldata = after;
  }

  trackEvent(eventName, eventData, omitKeys = []) {
    this.#setDigitalData(eventData, { omitKeys });

    this.logEvent(`custom-tracking:${eventName}`, {
      eventName,
      eventData,
      digitaldata: this.#digitaldata,
    });

    this.#satellite.track(eventName);
  }

  trackClick(event, eventName, eventData, omitKeys = []) {
    this.#setDigitalData(eventData, { omitKeys });

    this.logEvent(event.type, {
      eventName,
      eventData,
      digitaldata: this.#digitaldata,
    });

    this.#satellite.track(eventName);
  }

  trackFormSubmit(event, $form, onSubmitEventName, onSubmitEventData, omitKeys = []) {
    const convertedFieldData = this.convertDataToFieldData(onSubmitEventData, $form);
    this.#setDigitalData(convertedFieldData, { omitKeys });

    this.logEvent(event.type, {
      event,
      $form,
      onSubmitEventName,
      onSubmitEventData,
      convertedFieldData,
      digitaldata: this.#digitaldata,
    });

    this.#satellite.track(onSubmitEventName);
  }

  trackGFFormConfirmation(event, formId) {
    this.logEvent(event.type, { event, formId });
  }
}
